(function(w, $) {
    $(function() {
        const inputs = $('input[data-store],textarea[data-store]');
        $.each(inputs, function() {
            const t = $(this);
            const store = t.attr('data-store');
            if (store) {
                const key = store + '-' + t.attr('id');
                const currentValue = t.val();
                if (!currentValue || currentValue.length === 0) {
                    const lsValue = w.getFromLocalStorage(key);
                    if (lsValue) {
                        t.val(lsValue);
                    }
                }

                t.keyup(function() {
                    const val = t.val();
                    if (val && val.length > 0) {
                        w.saveToLocalStorage(key, t.val());
                    } else {
                        w.removeFromLocalStorage(key);
                    }
                });
            }
        });
    });
})(window, jQuery);